module.exports = __webpack_public_path__ + "img/030.cde64c63.png";